import { LocationType } from '~/client/graph'
import FieldIds from '~/client/src/shared/enums/DeliveryFieldIds'
import MapViewLocationIcon from '~/client/src/shared/enums/SitemapAttributeIcon'
import ILocationAttributeDto from '~/client/src/shared/types/ILocationAttributeDto'

import LocationAttributeBase from './LocationAttributeBase'

export default class Route extends LocationAttributeBase<Route> {
  public static fromDto(dto: ILocationAttributeDto) {
    return LocationAttributeBase.factory(Route, dto, MapViewLocationIcon.Route)
  }

  public type = LocationType.Route
  protected relatedFieldId = FieldIds.ROUTE
  protected model = Route
}
